/*globals globalAngularTrackingData:true */

angular.module('b2bLoginApp.controllers').controller('CompanyProfilePublicController', ["$scope", "$uibModal", "Upload", function ($scope, $uibModal, Upload) {
    $scope.canUpload = true;
    $scope.uploadError = false;

    $scope.sendPageViewEvent = function () {
        try {
            globalAngularTrackingData.pageTemplate = 'public_profile';
            window.SelfServiceGATracker.sendPageViewEvent(globalAngularTrackingData);
        } catch (error) {
            console.error('Error while sending data to GA: ', error);
        }
    };

    $scope.sendPageViewEvent();

    $scope.notices = {
        upload: false,
        uploadErrorMaxSize: false,
        uploadErrorMaxDimension: false,
        uploadErrorAjax: false
    };

    var templateBaseUrl = '/account/company-profile-public/';
    $scope.photoModalTemplates = {
        'addPhoto': templateBaseUrl + 'add-photo.html',
        'editPhoto': templateBaseUrl + 'edit-photo.html',
        'uploadPhoto': templateBaseUrl + 'upload-photo.html',
        'addPhotoDescription': templateBaseUrl + 'add-photo-description.html'
    };

    $scope.loadTemplate = function (template) {
        $scope.photoModalTemplate = $scope.photoModalTemplates[template];
    };

    $scope.logoUploadSuccessCallback = function (uploadResponse, profile) {
        if (!uploadResponse.data.url) {
            $scope.notices.uploadErrorAjax = true;
            $scope.uploadError = true;
            $scope.loadTemplate('addPhoto');

            return false;
        }

        profile.logo = uploadResponse.data;

        return true;
    };

    $scope.clearErrors = function (scope) {
        scope.uploadError = false;
        scope.notices.uploadErrorMaxSize = false;
        scope.notices.uploadErrorMaxDimension = false;
        scope.notices.uploadErrorAjax = false;
    };

    $scope.cropperWidth = 200;
    $scope.cropperHeight = 200;

    $scope.openAddPhotoDialog = function (successCallback, cropperWidth, cropperHeight, profile, isLogoUpload) {
        var photoTrackingId = isLogoUpload ? 'pencil__your_logo' : 'add_image__upload_project_photo';
        try {
            window.SelfServiceGATracker.sendButtonClickEvent(photoTrackingId, $scope.company.id);
        } catch (e) { /* tracker not loaded */ }

        $scope.isLogoUpload = isLogoUpload || false;
        var uploadBaseUrl = '/account/' + $scope.company.id + '/company-profile-public/';

        var modal = $uibModal.open({
            template: '<div ng-include="photoModalTemplate"></div>',
            backdrop: 'static',
            keyboard: false,
            scope: $scope,
            size: 'lg',
            openedClass: 'company-profile-modal company-photos-modal modal-open',
            controller: ["$scope", "$window", function ($scope, $window) {
                // initially load the addPhoto template
                $scope.loadTemplate('addPhoto');

                $scope.isPhotoSelected = false;

                $scope.cropperWidth = cropperWidth;
                $scope.cropperHeight = cropperHeight;

                $scope.selectPhoto = function (file, invalidFiles) {
                    if (invalidFiles.length !== 0) {
                        if (invalidFiles[0].$error === 'maxWidth' || invalidFiles[0].$error === 'maxHeight') {
                            $scope.notices.uploadErrorMaxDimension = true;
                        } else {
                            $scope.notices.uploadErrorMaxSize = true;
                        }
                        $scope.uploadError = true;

                        return;
                    }

                    // The behavior of the ng-file-upload library requires a null check
                    // See https://github.com/danialfarid/ng-file-upload/issues/1232
                    if (!file) {
                        return;
                    }

                    // set errors to false, if the user tries to add new photo, for the old errors to disappear
                    $scope.clearErrors($scope);

                    file.url = $window.URL.createObjectURL(file);

                    $scope.selectedPhoto = file;
                    $scope.isPhotoSelected = true;
                };

                $scope.uploadPhoto = function () {
                    if (!$scope.selectedPhoto) {
                        // TODO - Show error message? Need to make sure we have a selected photo
                        return;
                    }

                    $scope.uploadProgress = 0;
                    $scope.clearErrors($scope);
                    $scope.loadTemplate('uploadPhoto');

                    var image = new Image();
                    image.addEventListener('load', function(event) {
                        var data = {
                            'file': $scope.selectedPhoto,
                            'points': [0, 0, event.target.width, event.target.height],
                            'zoom': 'original',
                            'isLogo': $scope.isLogoUpload,
                        };
                        if ($scope.selectedPhoto.crop) {
                            data = {
                                'file': $scope.selectedPhoto,
                                'points': $scope.selectedPhoto.crop.points,
                                'zoom': $scope.selectedPhoto.crop.zoom,
                                'description': $scope.selectedPhoto.description,
                                'isLogo': $scope.isLogoUpload,
                            };
                        }

                        Upload.upload({
                            url: uploadBaseUrl + 'photo.json',
                            data: data,
                            headers: {
                                'useTracker': false
                            }
                        }).then(function (resp) {
                            if (typeof successCallback === 'function' && successCallback(resp, profile)) {
                                $scope.clearErrors($scope);
                            }

                            $scope.$root.$broadcast('profile:updated');

                            if($scope.isPhotoSelected && !$scope.uploadError) {
                                modal.close();
                            }
                        }, function () {
                            $scope.uploadProgress = 0;
                            // add the ajax error
                            $scope.notices.uploadErrorAjax = true;
                            $scope.uploadError = true;
                            // and move back to addPhoto
                            $scope.loadTemplate('addPhoto');
                        }, function (evt) {
                            $scope.uploadProgress = parseInt(100.0 * evt.loaded / evt.total);
                        });
                    });
                    image.src = $scope.selectedPhoto.url;
                };
            }]
        });
    };
}]);
